<template></template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Alerts',
  props: ['category'],
  data() {
    return {}
  },
  async created() {
    try {
      await this.get(`library/filter?category=${this.category}`).then(
        (data) => {
          const { model } = data

          if (model) {
            var name, config

            name = model.name
            config = {
              closeButton: true,
              timeOut: 0,
              extendedTimeOut: 0,
              progressBar: true,
              positionClass: 'toast-bottom-left',
              preventDuplicates: true,
            }
            window.$toast.warning(model.description, name, config)
          }
        }
      )
    } catch (error) {
      window.$toast.error(error)
    }
  },
  methods: {
    ...mapActions(['get']),
  },
}
</script>



// WEBPACK FOOTER //
// Alerts.vue?debf7ed8